const typographyVariants = {
    pageTitle: 'font-bold text-32 leading-tight',
    drawerTitle: 'font-bold text-28 leading-10',
    sectionTitle: 'font-bold text-20 leading-7 tracking-h5',
    subsectionTitle: 'font-bold text-18 leading-6 tracking-h5',
    body: 'text-16 leading-6',
    bodyBold: 'font-bold text-16 leading-6',
    bodySmall: 'text-14 leading-5',
    bodySmallBold: 'font-bold text-14 leading-5',
    listTitle: 'font-bold text-14 leading-5 tracking-h5',
    listText: 'text-14 leading-5 tracking-body',
    metricValue: 'font-bold text-14 leading-5 tracking-h5',
    inlineButton: 'font-bold text-14 leading-5 tracking-h5',
} as const;

export type TypographyVariant = keyof typeof typographyVariants;

export default typographyVariants;
